import { render, staticRenderFns } from "./answer_record.vue?vue&type=template&id=201a93d9&scoped=true"
import script from "./answer_record.vue?vue&type=script&lang=js"
export * from "./answer_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a93d9",
  null
  
)

export default component.exports